import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { raceResultById } from '../../store/selectors/resultsSelectors';
import { getRaceById } from '../../store/reducers/Results/resultsSlice';
import { useResults } from '../../hooks/useResults';
import cn from 'classnames';
import styles from './OneResultView.module.scss';
import ResultDetail from './ResultDetail/ResultDetail';
import ResultView from './ResultView/ResultView';
const OneResultView = () => {
    const params = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const race = useSelector((state) => raceResultById(state, params.id));
    const [active, setActive] = useState(false);
    useEffect(() => {
        if (race) {
            dispatch(getRaceById(race.id));
        }
    }, [race, dispatch]);
    useResults();
    const handleNavigateTo = () => {
        navigate(-1);
    };
    const handleRaceResultClick = () => {
        setActive(true);
    };
    const handleReplayRaceClick = () => {
        // TODO: not implemented yet
    };
    const handleClose = () => {
        setActive(false);
    };
    return (_jsxs("div", Object.assign({ className: cn('d-flex', styles.element) }, { children: [_jsx("div", Object.assign({ className: 'd-flex flex-column justify-content-between' }, { children: _jsx(ResultDetail, { raceDetails: race || null, navigateTo: handleNavigateTo, className: cn(styles.wrapper), onRaceResultsClick: handleRaceResultClick, onReplayRaceClick: handleReplayRaceClick }) })), _jsx("div", Object.assign({ className: cn(styles.trackImgContainer) }, { children: _jsx(ResultView, { className: cn(styles.details, active && styles['isActive']), onClose: handleClose }) }))] })));
};
export default OneResultView;
